import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ClientHubCreateClientPanel from '../clientHub/ClientHubCreateClientPanel';
import { fetchClientsOrder } from '../../slices/clientSlice';
import { fetchSelf } from '../../slices/userSlice';

export default function CreateNewClient({ onClose }) {
	const dispatch = useDispatch();
	const clients = useSelector((state) => state?.clients?.items) || [];
	const currentUserId = useSelector((state) => state?.auth?.self?.id);

	useEffect(() => {
		if (!currentUserId) {
			dispatch(fetchSelf());
		}

		if (!clients.length) {
			dispatch(fetchClientsOrder());
		}
	}, [clients.length, currentUserId, dispatch]);

	const handleClientReady = (clientId) => {
		if (clientId) {
			localStorage.setItem('clientId', JSON.stringify({ id: clientId }));
		}
	};

	return (
		<div className="new-order-client-intake">
			<ClientHubCreateClientPanel
				clients={clients}
				currentUserId={currentUserId}
				onCancel={onClose}
				onClientReady={handleClientReady}
				variant="embedded"
				eyebrow="Quote Setup"
				title="Select or Create a Client"
				description="Search by phone first, reuse matching records, and continue straight into the new order as soon as a client is ready."
				cancelLabel="Cancel Quote"
				submitLabel="Create Client and Continue"
				submittingLabel="Saving Client..."
				duplicateSubmitLabel="Continue With Existing Client"
				exactDuplicateActionLabel="Continue With Existing Client"
			/>
		</div>
	);
}
